import { render, staticRenderFns } from "./assignWorker.vue?vue&type=template&id=246aae37&scoped=true"
import script from "./assignWorker.vue?vue&type=script&lang=js"
export * from "./assignWorker.vue?vue&type=script&lang=js"
import style0 from "./assignWorker.vue?vue&type=style&index=0&id=246aae37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246aae37",
  null
  
)

export default component.exports